// Test de TÉCNICAS DE ESTUDIO — el del Laboratorio.
//
// Las cinco claves de los pesos son las familias del LAB (`LAB_CATEGORIES` en
// `data/alphaLab.js`, y su copia declarada en `app/domain/tests_alpha.py`).
//
// SE PUNTÚA AL REVÉS QUE LOS OTROS, y hay que saberlo para escribir bien las opciones:
// aquí puntuar alto en una familia significa que YA la usas. Lo útil es lo que falta, así
// que la recomendación sale de la cola. Por eso las opciones premian lo que el alumno HACE
// -no lo que le gustaría hacer- y por eso «no hago nada de eso» no puntúa: no puntuar es
// justo lo que hace que esa familia aparezca recomendada al final.
//
// Y una advertencia de tono: este test no mide inteligencia ni esfuerzo. Mide qué técnicas
// le han enseñado a alguien, que casi siempre es ninguna. El resultado tiene que leerse
// como «esto se aprende», nunca como «lo estás haciendo mal».
export const PREGUNTAS_TECNICAS = [
  {
    id: "t1",
    prompt: "Sin trampa: aquí no hay respuestas buenas ni malas.",
    question: "¿Conocías alguna técnica de estudio con nombre propio antes de esto?",
    options: [
      { id: "a", label: "Ninguna. Estudio como puedo.", weights: {} },
      { id: "b", label: "He oído hablar de alguna, pero no la uso", weights: { memoria: 1 } },
      { id: "c", label: "Uso una o dos de forma habitual", weights: { memoria: 2, organizacion: 1 } },
      { id: "d", label: "Varias, y voy cambiando según la asignatura", weights: { memoria: 1, organizacion: 2, lectura: 2 } },
    ],
  },
  {
    id: "t2",
    prompt: "Cómo estudias ahora:",
    question: "Tienes un tema para el viernes. Es lunes. ¿Qué haces?",
    options: [
      { id: "a", label: "Lo dejo para el jueves", weights: {} },
      { id: "b", label: "Voy leyendo un poco cada día, sin plan fijo", weights: { concentracion: 1 } },
      { id: "c", label: "Me reparto el tema por días", weights: { organizacion: 3 } },
      { id: "d", label: "Me reparto el tema y dejo un día solo para repasar", weights: { organizacion: 3, concentracion: 1 } },
    ],
  },
  {
    id: "t3",
    prompt: "Sobre la lectura:",
    question: "Abres el tema por primera vez. ¿Qué haces con él?",
    options: [
      { id: "a", label: "Leerlo entero de principio a fin", weights: {} },
      { id: "b", label: "Subrayar lo que me parece importante", weights: { lectura: 1 } },
      { id: "c", label: "Mirar primero títulos y apartados para saber qué viene", weights: { lectura: 3 } },
      { id: "d", label: "Convertirlo en preguntas y luego buscar las respuestas", weights: { lectura: 3, examenes: 1 } },
    ],
  },
  {
    id: "t4",
    prompt: "La prueba de fuego:",
    question: "¿Cómo compruebas que te lo sabes?",
    options: [
      { id: "a", label: "Cuando lo leo y me suena todo", weights: {} },
      { id: "b", label: "Releyendo los apuntes otra vez", weights: {} },
      { id: "c", label: "Tapando y tratando de contarlo de memoria", weights: { memoria: 3 } },
      { id: "d", label: "Explicándoselo a alguien, o en voz alta a la pared", weights: { memoria: 3, concentracion: 1 } },
    ],
  },
  {
    id: "t5",
    prompt: "Sobre el repaso:",
    question: "Un tema que estudiaste hace tres semanas, ¿cuándo lo vuelves a ver?",
    options: [
      { id: "a", label: "En la semana del examen final", weights: {} },
      { id: "b", label: "Cuando me acuerdo", weights: {} },
      { id: "c", label: "Le doy un repaso corto de vez en cuando", weights: { memoria: 2 } },
      { id: "d", label: "Tengo repasos programados y voy espaciándolos", weights: { memoria: 2, organizacion: 2 } },
    ],
  },
  {
    id: "t6",
    prompt: "Sobre el móvil, que hay confianza:",
    question: "Cuando estudias, ¿dónde está?",
    options: [
      { id: "a", label: "En la mano, básicamente", weights: {} },
      { id: "b", label: "Al lado, boca abajo", weights: { concentracion: 1 } },
      { id: "c", label: "En otra habitación, o en silencio dentro de un cajón", weights: { concentracion: 3 } },
      { id: "d", label: "Fuera, y además estudio por tramos con descansos marcados", weights: { concentracion: 3, organizacion: 2 } },
    ],
  },
  {
    id: "t7",
    prompt: "Concentración:",
    question: "¿Cuánto aguantas seguido sin levantarte ni cambiar de cosa?",
    options: [
      { id: "a", label: "Cinco minutos y ya estoy en otra pestaña", weights: {} },
      { id: "b", label: "Un rato, pero sin saber cuánto", weights: { concentracion: 1 } },
      { id: "c", label: "Trabajo por tramos de tiempo medidos", weights: { concentracion: 3 } },
      { id: "d", label: "Puedo meterme una hora larga sin interrupciones", weights: { concentracion: 3, examenes: 1 } },
    ],
  },
  {
    id: "t8",
    prompt: "El examen:",
    question: "Te dan el examen. ¿Qué es lo primero que haces?",
    options: [
      { id: "a", label: "Empezar por la primera pregunta", weights: {} },
      { id: "b", label: "Leerlo entero antes de escribir nada", weights: { examenes: 2 } },
      { id: "c", label: "Leerlo entero y repartir el tiempo por preguntas", weights: { examenes: 3 } },
      { id: "d", label: "Repartir el tiempo y dejar minutos al final para revisar", weights: { examenes: 3, organizacion: 1 } },
    ],
  },
  {
    id: "t9",
    prompt: "Las preguntas largas:",
    question: "Una pregunta de desarrollo de diez líneas. ¿Cómo la atacas?",
    options: [
      { id: "a", label: "Escribo todo lo que sé del tema", weights: {} },
      { id: "b", label: "Pienso un poco y empiezo", weights: { examenes: 1 } },
      { id: "c", label: "Hago un guion de cuatro puntos y lo sigo", weights: { examenes: 3, organizacion: 1 } },
      { id: "d", label: "Guion, y además cuido cómo empieza y cómo termina", weights: { examenes: 3, lectura: 1 } },
    ],
  },
  {
    id: "t10",
    prompt: "Cuando hay que memorizar de verdad:",
    question: "Una lista de doce cosas que van juntas. ¿Qué haces?",
    options: [
      { id: "a", label: "Repetirla hasta que se quede", weights: {} },
      { id: "b", label: "Escribirla varias veces", weights: { memoria: 1 } },
      { id: "c", label: "Partirla en grupos pequeños", weights: { memoria: 3 } },
      { id: "d", label: "Grupos pequeños y una regla para acordarme del orden", weights: { memoria: 3, examenes: 1 } },
    ],
  },
  {
    id: "t11",
    prompt: "Los apuntes:",
    question: "¿Qué aspecto tienen los tuyos?",
    options: [
      { id: "a", label: "No tengo. Uso los del libro o los de alguien.", weights: {} },
      { id: "b", label: "Lo que dice el profesor, tal cual", weights: { lectura: 1 } },
      { id: "c", label: "Con mis palabras y un resumen al final", weights: { lectura: 3 } },
      { id: "d", label: "Con mis palabras, resumen y preguntas al margen", weights: { lectura: 3, examenes: 1 } },
    ],
  },
  // LAS CINCO QUE LLEGARON DEL TEST DE RUTA el 18 de octubre de 2026, y una sexta nueva.
  //
  // POR QUE ESTABAN ALLI Y VIENEN AQUI. En ruta preguntaban por el repaso, los apuntes y la
  // constancia, y con eso repartian puntos entre competencias: saber que alguien repasa
  // espaciado no dice si le conviene Filosofia o Latin. Aqui si dice algo, porque este test
  // mide exactamente eso: que tecnicas usa ya y cuales no le han ensenado.
  //
  // Y SE PUNTUAN AL REVES, como todas las de este fichero: puntuar alto significa que YA lo
  // haces, y la recomendacion sale de la cola. Por eso «me frustra» o «lo acepto» valen
  // cero: no son peores personas, son familias que todavia no tiene.
  {
    id: "t13",
    prompt: "Sobre lo que se queda:",
    question: "Cuando aprendes algo nuevo, después…",
    options: [
      { id: "a", label: "Necesito repasarlo pronto o lo olvido", weights: { memoria: 1 } },
      { id: "b", label: "Se me queda si me impactó", weights: {} },
      { id: "c", label: "Solo se fija cuando lo aplico o lo discuto", weights: { memoria: 3 } },
      { id: "d", label: "Lo integro rápido si conecta con lo demás", weights: { lectura: 2, memoria: 1 } },
    ],
  },
  {
    id: "t14",
    prompt: "Y sobre lo que se va:",
    question: "¿Qué relación tienes con el olvido?",
    options: [
      { id: "a", label: "Lo evito con repasos a lo largo del tiempo", weights: { memoria: 3, organizacion: 1 } },
      { id: "b", label: "Lo acepto como parte de la mente", weights: {} },
      { id: "c", label: "Confío en que lo esencial vuelve", weights: {} },
      { id: "d", label: "Me frustra profundamente", weights: {} },
    ],
  },
  {
    id: "t15",
    prompt: "Sobre tus notas:",
    question: "¿Cómo organizas tus notas o ideas?",
    options: [
      { id: "a", label: "Con números, listas y tablas", weights: { organizacion: 2 } },
      { id: "b", label: "En un cuaderno, a mi manera", weights: {} },
      { id: "c", label: "Con mapas de palabras y flechas", weights: { lectura: 2, organizacion: 1 } },
      { id: "d", label: "No las organizo: confío en la memoria", weights: {} },
    ],
  },
  {
    id: "t16",
    prompt: "Sobre la constancia:",
    question: "¿Cuál es tu relación con la disciplina de estudio?",
    options: [
      { id: "a", label: "Necesito rutina y planificación estricta", weights: { organizacion: 3 } },
      { id: "b", label: "Cuando me pongo, me pongo", weights: { concentracion: 2 } },
      { id: "c", label: "Solo si el tema me apasiona", weights: {} },
      { id: "d", label: "Aprendo mejor hablándolo con alguien", weights: { memoria: 1 } },
    ],
  },
  {
    id: "t17",
    prompt: "Cuando algo se te resiste:",
    question: "¿Qué haces con los conceptos que no entiendes?",
    options: [
      { id: "a", label: "Los desmenuzo hasta comprenderlos", weights: { lectura: 2 } },
      { id: "b", label: "Los dejo madurar y vuelvo después", weights: {} },
      { id: "c", label: "Pregunto a alguien que sepa", weights: {} },
      { id: "d", label: "Los expreso con otras palabras", weights: { memoria: 2, lectura: 1 } },
    ],
  },
  // Y LA QUE FALTABA, QUE NO PUNTUA NADA A PROPOSITO. No dice que tecnicas usa: dice si hay
  // prisa. Con un examen la semana que viene, la primera tecnica que se recomienda no puede
  // ser una que tarda un mes en notarse. Lo ordena el servidor; aqui solo se pregunta.
  {
    id: "t18",
    prompt: "Y lo último, para saber si corre prisa:",
    question: "¿Tienes algún examen importante en las próximas dos semanas?",
    options: [
      { id: "a", label: "Sí, uno", weights: {} },
      { id: "b", label: "Sí, varios", weights: {} },
      { id: "c", label: "No, de momento no", weights: {} },
      { id: "d", label: "No lo sé", weights: {} },
    ],
  },
  {
    id: "t12",
    prompt: "La última, y es la que importa:",
    question: "¿Crees que podrías estudiar mejor de lo que estudias ahora?",
    options: [
      { id: "a", label: "Sí, y no sé por dónde empezar", weights: {} },
      { id: "b", label: "Sí, pero me falta constancia más que método", weights: { organizacion: 1 } },
      { id: "c", label: "Algo se podría afinar", weights: { organizacion: 1, lectura: 1 } },
      { id: "d", label: "Estoy bastante contento con cómo lo hago", weights: { organizacion: 2, lectura: 1, concentracion: 2 } },
    ],
  },
];
